import { ELanguage, IDropdownItem } from '@smartshell/ui-kit';

export const LANGUAGE_OPTIONS: IDropdownItem<ELanguage>[] = [
  { value: ELanguage.RU, title: 'Русский' },
  { value: ELanguage.EN, title: 'English' },
  { value: ELanguage.VI, title: 'Tiếng Việt' },
  { value: ELanguage.ES, title: 'Español' },
  { value: ELanguage.KK, title: 'Қазақша' },
  { value: ELanguage.UZ, title: 'O‘zbekcha' },
  { value: ELanguage.KY, title: 'Кыргыз' },
  { value: ELanguage.AZ, title: 'Azərbaycan' },
  { value: ELanguage.PT, title: 'Português' },
  { value: ELanguage.FR, title: 'Français' },
  { value: ELanguage.TR, title: 'Türk' },
  { value: ELanguage.DE, title: 'Deutsch' },
];

export const getLanguageTitle = (language: ELanguage): string =>
  LANGUAGE_OPTIONS.find(({ value }) => value === language)?.title ?? 'English';
